import React from 'react';
import { FolderKanban, Plus } from 'lucide-react';
import { Button } from '../ui/Button';

export const ProjectsEmptyState = ({ title, body, actionLabel, onAction, compact = false }) => (
  <div
    className={`flex flex-col items-center justify-center rounded-xl border border-dashed border-neutral-200 bg-transparent text-center dark:border-neutral-800 ${
      compact ? 'col-span-full px-4 py-8' : 'col-span-full px-6 py-14'
    }`}
  >
    <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-neutral-200 bg-neutral-50 text-neutral-500 dark:border-neutral-800 dark:bg-neutral-900">
      <FolderKanban size={20} />
    </div>
    <h3 className="mt-4 text-sm font-semibold text-neutral-900 dark:text-white">{title}</h3>
    <p className="mt-2 max-w-md text-sm leading-6 text-neutral-500">{body}</p>
    {actionLabel && onAction ? (
      <Button className="mt-5" onClick={onAction}>
        <Plus size={16} />
        {actionLabel}
      </Button>
    ) : null}
  </div>
);
